import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/main-logo1x1.png'
import _imports_1 from '@/assets/comp-logo.png'
import _imports_2 from '@/assets/main-logo1x1-dark.png'


const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "flex items-center justify-center h-16 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_3 = { class: "flex items-center justify-center space-x-2 px-2 w-full transition-all duration-300" }
const _hoisted_4 = { class: "h-8 flex items-center justify-center flex-shrink-0" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: "Logo",
  class: "h-10 transition-all duration-300 dark:hidden"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  alt: "Logo",
  class: "h-10 lg:hidden transition-all duration-300 dark:hidden"
}
const _hoisted_7 = {
  key: 2,
  src: _imports_1,
  alt: "Logo",
  class: "h-8 hidden lg:block transition-all duration-300 dark:hidden"
}
const _hoisted_8 = {
  key: 3,
  src: _imports_2,
  alt: "Logo",
  class: "h-10 transition-all duration-300 hidden dark:block"
}
const _hoisted_9 = {
  key: 4,
  src: _imports_1,
  alt: "Logo",
  class: "h-8 hidden lg:dark:block transition-all duration-300"
}
const _hoisted_10 = { class: "flex-1 px-2 py-4 space-y-1 overflow-y-auto" }
const _hoisted_11 = {
  key: 0,
  class: "absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-primary to-primary-hover dark:from-primary-dark dark:to-sec-dark-hover rounded-r-full"
}
const _hoisted_12 = {
  key: 0,
  class: "p-4 border-t border-gray-200 dark:border-gray-700 transition-all duration-300"
}
const _hoisted_13 = { class: "flex items-center justify-center space-x-2 text-xs text-primary-text dark:text-primary-dark-text" }

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getNavigationItems } from '@/router'
import { useUser } from '@/composables/auth/useUser'

// Props & Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    isOpen: { type: Boolean },
    isCollapsed: { type: Boolean }
  },
  emits: ["update:isOpen", "update:isCollapsed"],
  setup(__props: any, { emit: __emit }) {

// Imports
const props = __props

const emit = __emit

// Composables
const route = useRoute()
const router = useRouter()
const { userType } = useUser()

// Computed Properties
const navigation = computed(() => getNavigationItems([...router.options.routes], userType.value))

// Methods
const isActive = (path: string) => route.path === path
const toggleSidebar = () => emit('update:isOpen', !props.isOpen)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", {
      class: _normalizeClass(["fixed inset-y-0 left-0 z-50 bg-white dark:bg-gray-800 shadow-xl transform transition-all duration-300 ease-in-out lg:translate-x-0", [
      { '-translate-x-full': !_ctx.isOpen, 'translate-x-0': _ctx.isOpen },
      { 'w-64': !_ctx.isCollapsed, 'w-64 lg:w-20': _ctx.isCollapsed }
    ]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6)),
              (_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true),
              (!_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("nav", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.to,
              to: item.to,
              class: _normalizeClass(["group flex items-center py-2.5 text-primary-text dark:text-primary-dark-text rounded-lg transition-all duration-200 relative overflow-hidden", [
            {
              'bg-gradient-to-r from-primary-bg to-primary-bg/10 dark:from-primary-dark/20 dark:to-primary-dark/50 text-primary dark:text-primary-dark': isActive(item.to),
              'hover:bg-primary-bg dark:hover:bg-primary-dark-bg/20': !isActive(item.to),
              'lg-tooltip': _ctx.isCollapsed
            },
            _ctx.isCollapsed ? 'px-2 lg:justify-center' : 'px-3',
            _ctx.isCollapsed ? 'justify-start lg:justify-center' : 'justify-start'
          ]]),
              title: _ctx.isCollapsed ? item.name : ''
            }, {
              default: _withCtx(() => [
                (isActive(item.to))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center transition-all duration-200 relative z-10", {
              'lg:justify-center space-x-3 lg:space-x-0': _ctx.isCollapsed,
              'space-x-3': !_ctx.isCollapsed
            }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex items-center justify-center rounded-lg transition-all duration-200", [
                {
                  'bg-primary-bg/20 dark:bg-primary-dark/20': isActive(item.to),
                  'bg-primary-bg/50 dark:bg-primary-dark-bg/50': !isActive(item.to)
                },
                _ctx.isCollapsed ? 'w-10 h-10' : 'w-8 h-8'
              ]])
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                      class: _normalizeClass([
                  'w-5 h-5 flex-shrink-0 transition-all duration-200 group-hover:scale-110',
                  isActive(item.to) 
                    ? 'text-primary dark:text-primary-dark' 
                    : 'text-primary-text/70 dark:text-primary-dark-text/70 group-hover:text-primary/80 dark:group-hover:text-primary-dark/80'
                ])
                    }, null, 8, ["class"]))
                  ], 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-sm font-bold truncate transition-all duration-200", {
                'lg:hidden': _ctx.isCollapsed,
                'block': !_ctx.isCollapsed
              }])
                  }, _toDisplayString(item.name), 3)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["absolute inset-0 opacity-0 group-hover:opacity-100 bg-gradient-to-r from-primary/5 via-primary/10 to-primary/5 dark:from-primary-dark/5 dark:via-primary-dark/10 dark:to-primary-dark/5 transition-all duration-300", { 'opacity-0': isActive(item.to) }])
                }, null, 2)
              ]),
              _: 2
            }, 1032, ["to", "class", "title"]))
          }), 128))
        ]),
        (!_ctx.isCollapsed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", null, "© " + _toDisplayString(new Date().getFullYear()), 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "w-1 h-1 rounded-full bg-primary-bg dark:bg-primary-dark-bg" }, null, -1)),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Developed by Proweaver", -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-40 bg-black/50 backdrop-blur-sm lg:hidden transition-opacity duration-300",
          onClick: toggleSidebar
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})